const DEFAULT_MINLEN = 1
const WAITING_MINLEN = 2

export const determineMinlen = data => {
  if (data.scope.live() == true) {
    return data
  }

  const waitingNodes = data.nodes.filter(node =>
    data.scope.waitingNodeIds.includes(node.id)
  )

  waitingNodes.map(node => {
    data.edges.map(edge => {
      if (
        parseInt(edge.source) == node.id ||
        node.siblings.filter(sibling => sibling == parseInt(edge.source))
          .length > 0 ||
        parseInt(edge.v) == node.id ||
        node.siblings.filter(sibling => sibling == parseInt(edge.v)).length > 0
      ) {
        edge.minlen = WAITING_MINLEN
      } else {
        edge.minlen = DEFAULT_MINLEN
      }
    })
  })

  return data
}

